import { render, staticRenderFns } from "./InstructivoCriterioDialog.vue?vue&type=template&id=3108615e&scoped=true&"
import script from "./InstructivoCriterioDialog.vue?vue&type=script&lang=js&"
export * from "./InstructivoCriterioDialog.vue?vue&type=script&lang=js&"
import style0 from "./InstructivoCriterioDialog.vue?vue&type=style&index=0&id=3108615e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108615e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VDivider,
  VSpacer,
})
